export default __webpack_public_path__ + "static/media/ast-01.a4e0295d.png";